import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LOCALES, type LocaleCode } from "./locales";
import { translations } from "./translations";
import { safeStorage } from "@/utils/storage";

/** Coerces route/storage input to a supported locale with an English fallback. */
export function normalizeLocale(value: string | undefined | null): LocaleCode {
    return value && value in LOCALES ? value as LocaleCode : "en";
}

function initialLocale(): LocaleCode {
    if (typeof window !== "undefined") {
        const first = window.location.pathname.split("/").filter(Boolean)[0];
        if (first && first in LOCALES) return first as LocaleCode;
        const stored = safeStorage.getItem("pitango-locale");
        if (stored && stored in LOCALES) return stored as LocaleCode;
    }
    return "en";
}

void i18n.use(initReactI18next).init({
    resources: {
        en: { translation: translations.en },
        he: { translation: translations.he },
        th: { translation: translations.th }
    },
    lng: initialLocale(),
    fallbackLng: "en",
    supportedLngs: Object.keys(LOCALES),
    interpolation: { escapeValue: false }
});

/** Applies locale semantics to the document and persists the validated code. */
export function applyDocumentLocale(locale: LocaleCode): void {
    const definition = LOCALES[locale];
    document.documentElement.lang = definition.code;
    document.documentElement.dir = definition.direction;
    document.documentElement.dataset.locale = definition.code;
    safeStorage.setItem("pitango-locale", locale);
}

export { i18n };
